import { render } from "./SignInClient.vue?vue&type=template&id=33d60a26&scoped=true"
import script from "./SignInClient.vue?vue&type=script&lang=js"
export * from "./SignInClient.vue?vue&type=script&lang=js"

import "./SignInClient.vue?vue&type=style&index=0&id=33d60a26&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d60a26"]])

export default __exports__